define('view/disclosure/persistent.left.sidebar',['require','exports','module','underscore','blockit','uikit/uikit','backbone.radio','handlebars','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _          = require('underscore'),
      BlocKit    = require('blockit'),
      UIKit      = require('uikit/uikit'),
      Radio      = require('backbone.radio'),
      Handlebars = require('handlebars'),

  EnableOnlyOnUnsavedChangesBehavior = require('fukit').EnableOnlyOnUnsavedChangesBehavior;

  function getDisclosureReviewer() {
    var disclosureAssignmentDetailModel = Radio.request(
      'AppKit.resourceService',
      'resource',
      'disclosureAssignmentDetailModel'
    );
    return disclosureAssignmentDetailModel.get('disclosureReviewer.id');
  }

  var PersistentLeftSidebar = {
    components: [
      {
        type: BlocKit.LabeledComponentsContainerView,
        behaviors: {
          BindAndFormatOptionValuesBehavior: {
            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
            optionValues: {
              visible: {
                model: '@resources.disclosure',
                modelAttribute: 'status',
                formatter: function(status) {
                  return status === 'Disclosure Complete';
                },
              },
            },
          },
        },
        components: [
          {
            name: 'Disclosure Resolved',
            label: {
              text: 'Disclosure Resolved:',
            },
            content: {
              model: '@resources.disclosure',
              behaviors: {
                BindAndFormatOptionValuesBehavior: {
                  optionValues: {
                    text: {
                      modelAttribute: 'reviewerNameAndDate',
                    },
                  },
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                },
              },
            },
          },
          {
            name: 'Resolution',
            label: {
              text: 'Resolution:',
            },
            content: {
              model: '@resources.disclosure',
              behaviors: {
                BindAndFormatOptionValuesBehavior: {
                  optionValues: {
                    text: {
                      modelAttribute: 'decisionOutcome',
                    },
                  },
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                },
              },
            },
          },
        ],
      },
      {
        type: BlocKit.AttachedComponentsContainerView,
        className: 'ui coi-tasks',
        behaviors: {
          BindAndFormatOptionValuesBehavior: {
            behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
            optionValues: {
              visible: {
                model: '@resources.disclosure',
                modelAttribute: 'status',
                formatter: function(status) {
                  return status !== 'Disclosure Complete';
                },
              },
            },
          },
        },
        components: [
          // My Tasks
          {
            type: BlocKit.BasicTableView,
            collection: '@resources.workflowTaskModel.requiredActivityCollection',
            columns: [
              {
                text: 'My Tasks:',
                childView: UIKit.Text,
                childViewOptions: {
                  attributes: {
                    style: 'cursor: pointer;',
                  },
                  color: 'primary',
                  behaviors: {
                    assignColorFromAction: {
                      optionValues: {
                        color: {
                          //Task with no actions do not have a link appearance
                          formatter: function(model) {
                            var action = model.get('action');
                            if (action !== 'NONE') {
                              return 'primary';
                            }
                          },
                        },
                      },
                      behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                    },
                    formatTaskString: {
                      assignmentDetailModel: '@resources.disclosureAssignmentDetailModel',
                      disclosureModel: '@resources.disclosure',
                      workflowActivityStateModel: '@resources.workflowActivityStateModel',
                      optionValues: {
                        text: {
                          formatter: function(model) {
                            var workflowActivityStateModel = this.getOption('workflowActivityStateModel');
                            var assignmentDetailModel = this.getOption('assignmentDetailModel');
                            var disclosureModel = this.getOption('disclosureModel');
                            var reviewerAssignedClass = model.get('isComplete') ? 'strikethrough' : 'underline';
                            var requiredText = !model.get('isPassive')
                              ? ' <span class="text-required"> (Required)</span>'
                              : '';

                            var getTaskText = function() {
                              var taskText =
                                '<span class="text ' +
                                reviewerAssignedClass +
                                '">' +
                                model.get('displayName') +
                                '</span>';

                              if (model.get('action') === 'ASSIGN_REVIEWERS') {
                                if (model.get('isComplete') && assignmentDetailModel.get('disclosureReviewer')) {
                                  //Reviewer assignment has special UI display rules, as outlined in COI-204.
                                  //  If a reviewer has been assigned before the task has been completed,
                                  //  the UI displays text indicating the reviewer's name, a red "removal" icon,
                                  //  and the "required" label suppressed if applicable
                                  taskText +=
                                    '<div class="text coi-next-reviewer">Next Reviewer: ' +
                                    disclosureModel.get('disclosureReviewerName') +
                                    ' <i class="icon remove circle red"></i></div>';
                                  requiredText = '';
                                  workflowActivityStateModel.set({ disableActionButton: false });
                                } else {
                                  workflowActivityStateModel.set({ disableActionButton: true });
                                }
                              }
                              return taskText;
                            };

                            return new Handlebars.SafeString(getTaskText() + requiredText);
                          },
                        },
                      },
                      behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                    },
                  },
                },
              },
            ],
            childViewOptions: {
              bindings: {
                link: 'link',
              },
              disclosureModel: '@resources.disclosure',
              behaviors: function() {
                var model = this.getOption('model');
                var action = model.get('action');
                var userPrincipalModel = Radio.request('AppKit.resourceService', 'resource', 'userPrincipalModel');

                switch (action) {
                  case 'CONFIRM_REVIEW':
                    return {
                      ShowModalOnEventBehavior: {
                        modalName: 'confirmReviewCompletionModal',
                        behaviorClass: BlocKit.ShowModalOnEventBehavior,
                      },
                    };
                    break;
                  case 'ASSIGN_REVIEWERS':
                    return {
                      ShowModalOnEventBehavior: {
                        modalName: function() {
                          return !this.view.model.get('isComplete')
                            ? 'reviewerAssignmentModal'
                            : 'removeReviewerConfirmationModal';
                        },
                        behaviorClass: BlocKit.ShowModalOnEventBehavior,
                      },
                    };
                    break;
                  case 'MAKE_DECISION':
                    return {
                      ShowModalOnEventBehavior: {
                        modalName: 'decisionActivitySidebar',
                        behaviorClass: BlocKit.ShowModalOnEventBehavior,
                      },
                      hideDecisionTask: {
                        behaviorClass: Mn.Behavior.extend({
                          onFirstBeforeRender: function() {
                            //We aren't showing this in the task list anymore.  Hide it and prevent it from being unhidden
                            this.view.visible = false;
                            UIKit.freezeOption(this.view, 'visible');
                          },
                        }),
                      },
                    };
                    break;
                }
              },
            },
            emptyText: 'No tasks.',
          },
          {
            type: UIKit.ComponentsContainerView,
            className: 'actions',
            visible: false,
            behaviors: {
              setComponentVisibility: {
                behaviorClass: Mn.Behavior.extend({
                  onBeforeRender: function() {
                    var workflowActivityStateModel = Radio.request(
                      'AppKit.resourceService',
                      'resource',
                      'workflowActivityStateModel'
                    );

                    this.view.visible = !!workflowActivityStateModel.get('passActionModel');

                    this.listenTo(workflowActivityStateModel, 'change:passActionModel', function() {
                      this.view.visible = !!workflowActivityStateModel.get('passActionModel');
                    });
                  },
                }),
              },
            },
            childView: UIKit.Button,
            components: [
              {
                icon: 'send',
                text: 'Pass To First Reviewer',
                size: 'tiny',
                disabled: true,
                onPress: function() {
                  this.trigger('confirm:complete:task');
                },
                behaviors: {
                  setButtonModel: {
                    behaviorClass: Mn.Behavior.extend({
                      onFirstBeforeRender: function() {
                        var routingActionCollection = Radio.request(
                          'AppKit.resourceService',
                          'resource',
                          'disclosure.workflowTaskModel.formDataModel.routingActionCollection'
                        );

                        var findPassActionModel = function(routingActionCollection) {
                          var passActionModel = routingActionCollection.filter(function(model) {
                            var routingId = model.get('routingId');

                            //'YES' and 'REVIEWER' are the routingId's associated with the "Pass to reviewer" action buttons
                            return routingId === 'REVIEWER' || routingId === 'YES';
                          });
                          return passActionModel.length > 0 ? passActionModel[0] : null;
                        };

                        var passActionModel = findPassActionModel(routingActionCollection);

                        if (passActionModel) {
                          this.view.model = passActionModel;
                        }

                        this.listenTo(routingActionCollection, 'update sync change', function(routingActionCollection) {
                          var passActionModel = findPassActionModel(routingActionCollection);

                          if (passActionModel) {
                            this.view.model = passActionModel;
                          }
                        });
                      },
                    }),
                  },
                  InvokeModelMethodOnEventBehavior: {
                    eventName: 'confirm:complete:task',
                    method: 'completeTask',
                    targetModel: '@resources.workflowTaskModel',
                    methodArguments: function(workflowTaskModel) {
                      var getOptionalVariablesForReviewer = function() {
                        var disclosureAssignmentDetailModel = Radio.request(
                          'AppKit.resourceService',
                          'resource',
                          'disclosureAssignmentDetailModel'
                        );
                        var availableReviewersCollection = Radio.request(
                          'AppKit.resourceService',
                          'resource',
                          'availableReviewersCollection'
                        );
                        var disclosureReviewerId = disclosureAssignmentDetailModel.get('disclosureReviewer.id');
                        var reviewer = availableReviewersCollection.findWhere({
                          userAccountId: disclosureReviewerId,
                        });
                        var reviewerName = reviewer ? reviewer.get('fullName') : '';

                        return [
                          {
                            name: 'reviewerId',
                            value: disclosureReviewerId,
                            type: 'string',
                          },
                          {
                            name: 'reviewerFullName',
                            value: reviewerName,
                            type: 'string',
                          },
                        ];
                      };

                      var taskDefinitionKey = workflowTaskModel.get('taskDefinitionKey');
                      var requiredTaskVariable = {
                        name: taskDefinitionKey,
                        value: this.view.model.get('routingId'),
                        type: 'string',
                      };
                      var optionalTaskVariables = getOptionalVariablesForReviewer();

                      return [_.union([requiredTaskVariable], optionalTaskVariables)];
                    },

                    onMethodSuccess: function() {
                      var workflowActivityStateModel = Radio.request(
                        'AppKit.resourceService',
                        'resource',
                        'workflowActivityStateModel'
                      );

                      workflowActivityStateModel.set({ passActionModel: null });
                    },
                    behaviorClass: BlocKit.InvokeModelMethodOnEventBehavior,
                  },
                  BindAndFormatOptionValuesBehavior: {
                    optionValues: {
                      disabled: {
                        model: '@resources.workflowActivityStateModel',
                        modelAttribute: 'disableActionButton',
                        formatter: function(disableActionButton) {
                          return disableActionButton;
                        },
                      },
                      color: {
                        model: '@resources.workflowActivityStateModel',
                        modelAttribute: 'areAllActivitiesComplete',
                        formatter: function(areAllActivitiesComplete) {
                          return areAllActivitiesComplete ? 'primary' : 'secondary';
                        },
                      },
                      text: {
                        model: '@resources.workflowActivityStateModel',
                        formatter: function(passActionModel) {
                          return this.view.model.get('displayName');
                        },
                      },
                    },
                    behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                  },
                },
              },
            ],
          },
        ],
      },
      // Decisions - included in mockup, no current ticket
      //{},
      // Management Plan - included in mockup, no current ticket
      //{},
      // Disclosure Information - included in mockup, no current ticket
      {
        type: UIKit.Header,
        tagName: 'h4',
        text: 'Disclosure Information',
      },
      {
        type: BlocKit.LabeledComponentsContainerView,
        components: [
          {
            name: 'Date Submitted',
            label: {
              text: 'Date Submitted:',
            },
            content: {
              model: '@resources.disclosure',
              behaviors: {
                BindAndFormatOptionValuesBehavior: {
                  optionValues: {
                    text: {
                      modelAttribute: 'submitDate',
                      formatter: BlocKit.Formatter.date({
                        format: 'L',
                        emptyValue: '--',
                      }),
                    },
                  },
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                },
              },
            },
          },
          {
            name: 'Type',
            label: {
              text: 'Type:',
            },
            content: {
              model: '@resources.disclosure',
              behaviors: {
                BindAndFormatOptionValuesBehavior: {
                  optionValues: {
                    text: {
                      modelAttribute: 'templateTypeDescription',
                    },
                  },
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                },
              },
            },
          },
          {
            name: 'Status',
            label: {
              text: 'Status:',
            },
            content: {
              model: '@resources.disclosure',
              behaviors: {
                BindAndFormatOptionValuesBehavior: {
                  optionValues: {
                    text: {
                      modelAttribute: 'status',
                    },
                  },
                  behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                },
              },
            },
          },
        ],
      },
    ],
  };

  module.exports = PersistentLeftSidebar;
});

